import { Helmet } from 'react-helmet-async';
// sections
import { NewPlaylistView } from 'src/sections/new-playlist/view';

// ----------------------------------------------------------------------

export default function OverviewAppPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: New Playlist</title>
      </Helmet>

      <NewPlaylistView />
    </>
  );
}
